import { useEffect, useCallback } from "react";

let sharedAudioCtx: AudioContext | null = null;

function removeUnlockListeners() {
  document.removeEventListener("touchstart", unlockAudio, true);
  document.removeEventListener("touchend", unlockAudio, true);
  document.removeEventListener("click", unlockAudio, true);
}

function unlockAudio() {
  // Create fresh context inside the gesture — iOS requires this
  if (!sharedAudioCtx) {
    sharedAudioCtx = new AudioContext();
  }
  const ctx = sharedAudioCtx;

  // All synchronous within the gesture call stack
  ctx.resume();

  const buffer = ctx.createBuffer(1, 1, ctx.sampleRate);
  const source = ctx.createBufferSource();
  source.buffer = buffer;
  source.connect(ctx.destination);
  source.start(0);

  if (ctx.state === "running") {
    removeUnlockListeners();
  } else {
    ctx.onstatechange = () => {
      if (ctx.state === "running") {
        ctx.onstatechange = null;
        removeUnlockListeners();
      }
    };
  }
}

document.addEventListener("touchstart", unlockAudio, true);
document.addEventListener("touchend", unlockAudio, true);
document.addEventListener("click", unlockAudio, true);

function playChime() {
  try {
    if (!sharedAudioCtx || sharedAudioCtx.state !== "running") return;
    const ctx = sharedAudioCtx;
    const now = ctx.currentTime;

    const playTone = (freq: number, start: number, duration: number) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.3, start);
      gain.gain.exponentialRampToValueAtTime(0.001, start + duration);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(start);
      osc.stop(start + duration);
    };

    // Two-note ascending chime (D5 → A5)
    playTone(587.33, now, 0.15);
    playTone(880, now + 0.12, 0.2);
  } catch {
    // Audio not available
  }
}

export function useTurnNotification(isMyTurn: boolean) {
  const notify = useCallback(() => {
    playChime();
    navigator.vibrate?.(200);
  }, []);

  useEffect(() => {
    if (isMyTurn) {
      notify();
    }
  }, [isMyTurn, notify]);
}
